import axios from 'axios';
export default class UserInfo {
  constructor() {
    if (localStorage.getItem("nx_op") != null) {
      const data = JSON.parse(localStorage.getItem("nx_op"))
      this.TOKEN = data['token'];
      this.TIN = data['organization']['tin_number'];
      this.ORG_ID = data['organization']['organization_id'];
      this.ORG_TYPE = data['organization']['organization_type'];
      this.ORG_TP = data['organization']['tp'];
      this.OPERATOR_NAME = data['organization']['name'];
      this.USERNAMES = data['first_name'] + " " + data['last_name'];
      this.SHORT = data['first_name'].substr(0, 1);
    }

    if (localStorage.getItem("profile") != null) {
      const data = JSON.parse(localStorage.getItem("profile"));
      this.ID = data['operator']['id'];
      this.ORG_NAME = data['operator']['names'];
    }

    if(localStorage.getItem("profile_manager") != null){
    const data=JSON.parse(localStorage.getItem("profile_manager"));
    this.AGENT_CODE=data['agent_code'];
    this.USER_ID=data['user_id'];
    }

  }

  get_profile() {
    const data = JSON.parse(localStorage.getItem("nx_op"));
    const profileInstance = axios.create({
      baseURL: process.env.REACT_APP_TRANSPORT_URL,
      headers: {
        'Authorization': 'Bearer ' + data['token'],
        'Content-Type': 'application/json',
        'Access-Control-Allow-Origin': '*'
      },
    })
    profileInstance.get("/api/v1/integrations/loggedIn").then(res => {
      if (res.status == 200) {
        localStorage.setItem("profile", JSON.stringify(res.data.data));
      }
      console.log(res);
      console.log(res.data);
    });
  }

}


export { UserInfo };
